import React from 'react';
import { Box, H3 } from '@saladbob/sassafras';
import Link from 'next/link';

import type { CourtDepth } from '../../types';

const CourtCard = ({ court }: { court: CourtDepth }) => {
    console.log(court.title);
    return (
        <Link href={`/court/${court.id}`} title={court.label} target="_blank">
            <Box
                bgColor={court.color}
                padding="md"
                rounded="md"
                depth="md"
                verticalAlign="center"
                align="center"
                justify="center"
                style={{ aspectRatio: '1/1' }}
            >
                <H3 color={court.textColor} font="p" style={{ opacity: 0.5 }}>
                    {court.division}
                </H3>
                <H3 font={{ phone: 'leader', desktop: 'h1' }} color={court.textColor}>
                    {court.title || court.label}
                </H3>
            </Box>
        </Link>
    );
};

export default CourtCard;